import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
export function ReturnsPage() {
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-494">
      <Header data-id="element-495" />

      <main className="flex-grow pt-32 pb-20" data-id="element-496">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-497">
          {/* Title */}
          <h1 className="text-3xl md:text-4xl font-bold text-red-600 text-center uppercase mb-12" data-id="element-498">
            Returns & Refunds Policy
          </h1>

          <div className="space-y-10 text-gray-800 leading-relaxed" data-id="element-499">
            {/* Final Sale Items */}
            <section data-id="element-500">
              <h2 className="text-xl font-bold text-gray-900 uppercase mb-4" data-id="element-501">
                Final Sale Items
              </h2>
              <ul className="space-y-2" data-id="element-502">
                <li data-id="element-503">
                  • <strong data-id="element-504">Electronics</strong>,{' '}
                  <strong data-id="element-505">electronic headgear</strong>, and{' '}
                  <strong data-id="element-506">electronic chest protectors</strong> are{' '}
                  <strong data-id="element-507">non-returnable</strong>.
                </li>
                <li data-id="element-508">
                  • <strong data-id="element-509">Engraved</strong> or{' '}
                  <strong data-id="element-510">customized items</strong> are{' '}
                  <strong data-id="element-511">non-returnable</strong>.
                </li>
                <li data-id="element-512">
                  • <strong data-id="element-513">Used items</strong> are{' '}
                  <strong data-id="element-514">not eligible</strong> for return or exchange.
                </li>
              </ul>
            </section>

            {/* Dead on Arrival */}
            <section data-id="element-515">
              <h2 className="text-xl font-bold text-gray-900 uppercase mb-4" data-id="element-516">
                Dead on Arrival (DOA)
              </h2>
              <ul className="space-y-2" data-id="element-517">
                <li data-id="element-518">
                  • <strong data-id="element-519">Electronics</strong> that arrive defective are
                  eligible for <strong data-id="element-520">exchange only</strong>. Refunds are not
                  available for DOA items.
                </li>
              </ul>
            </section>

            {/* Returns */}
            <section data-id="element-521">
              <h2 className="text-xl font-bold text-gray-900 uppercase mb-4" data-id="element-522">
                Returns
              </h2>
              <ul className="space-y-2" data-id="element-523">
                <li data-id="element-524">
                  • <strong data-id="element-525">Reply to your confirmation order email</strong> to
                  request a return.
                </li>
                <li data-id="element-526">
                  • Returns are only on unused, without engravings, with the
                  packaging, <strong data-id="element-527">within 7 days</strong>.
                </li>
                <li data-id="element-528">
                  • <strong data-id="element-529">Shipping charges are non-refundable</strong> once an
                  item has shipped.
                </li>
                <li data-id="element-530">
                  • Approved refunds issued to a <strong data-id="element-531">credit card</strong>{' '}
                  are subject to a <strong data-id="element-532">5% return/transaction fee</strong>.
                </li>
              </ul>
            </section>

            {/* Warranties */}
            <section data-id="element-533">
              <h2 className="text-xl font-bold text-gray-900 uppercase mb-4" data-id="element-534">
                Warranties
              </h2>
              <ul className="space-y-2" data-id="element-535">
                <li data-id="element-536">
                  • Manufacturer warranties remain valid on engraved items.
                </li>
                <li data-id="element-537">
                  • Warranties for <strong data-id="element-538">Daedo socks and gloves</strong> cover{' '}
                  <strong data-id="element-539">normal wear and tear only</strong>.
                </li>
                <li data-id="element-540">
                  • For warranty claims or questions, contact info@tkdscore.com.
                </li>
              </ul>
            </section>
          </div>
        </div>
      </main>

      <Footer data-id="element-541" />
    </div>;
}